import {createApp} from 'vue'
import CategoryBannerButtons from './categorybannerbuttons.vue'

const categorybanner = createApp({
    data() {
        return {
        }
    },
})


// Create the vue app, add the component to it, then mount into the container #questions
categorybanner.component('CategoryBannerButtons', CategoryBannerButtons)

if (document.getElementById('categorybanner')) {
    categorybanner.mount('#categorybanner')
}